import { getMessageTimestampMs } from './normalizeMessageTimestamp';

const GROUP_WINDOW_MS = 5 * 60 * 1000;

function getMessageTimestamp(message) {
  return getMessageTimestampMs(message);
}

function isSameSender(a, b) {
  if (!a || !b) return false;
  return (a.origin || '') === (b.origin || '');
}

function isWithinGroupWindow(currentMessage, neighborMessage) {
  const currentTs = getMessageTimestamp(currentMessage);
  const neighborTs = getMessageTimestamp(neighborMessage);
  if (currentTs == null || neighborTs == null) return true;
  return Math.abs(currentTs - neighborTs) <= GROUP_WINDOW_MS;
}

/**
 * Annotates messages with grouping metadata for compact chat rendering.
 */
export function groupMessages(messages = []) {
  return messages.map((message, index) => {
    const previous = messages[index - 1];
    const next = messages[index + 1];

    const groupedWithPrevious =
      isSameSender(message, previous) && isWithinGroupWindow(message, previous);
    const groupedWithNext =
      isSameSender(message, next) && isWithinGroupWindow(message, next);

    return {
      message,
      isFirstInGroup: !groupedWithPrevious,
      isLastInGroup: !groupedWithNext,
      isGrouped: groupedWithPrevious || groupedWithNext,
    };
  });
}
